<template>
  <div class="cultura-esus-feedback">
    <!-- HEADER -->
    <CulturaHeader :active-tab="activeTab" @change-tab="activeTab = $event" />

    <!-- MAIN -->
    <main class="cultura-main">
      <!-- MODAL MANIFESTO -->
      <CulturaManifestoModal
        v-if="showManifesto"
        @close="showManifesto = false"
      />

      <!-- DASHBOARD -->
      <CulturaDashboard
        v-if="activeTab === 'dashboard'"
        :daily-quote="dailyQuote"
        @open-manifesto="showManifesto = true"
        @go-to-values="activeTab = 'values'"
        @refresh-quote="refreshQuote"
      />

      <!-- PILARES / VALORES -->
      <CulturaValues v-if="activeTab === 'values'" />

      <!-- COMUNICAÇÃO -->
      <CulturaCommunication v-if="activeTab === 'communication'" />
    </main>

    <!-- NAV MOBILE -->
    <CulturaMobileBottomNav
      :active-tab="activeTab"
      @change-tab="activeTab = $event"
    />
  </div>
</template>

<script>
import CulturaHeader from './components/CulturaHeader.vue'
import CulturaDashboard from './components/CulturaDashboard.vue'
import CulturaValues from './components/CulturaValues.vue'
import CulturaCommunication from './components/CulturaCommunication.vue'
import CulturaManifestoModal from './components/CulturaManifestoModal.vue'
import CulturaMobileBottomNav from './components/CulturaMobileBottomNav.vue'

const DAILY_REMINDERS = [
  'O feedback é a ponte para a excelência.',
  'Receber feedback é o que nos motiva a melhorar diariamente.',
  'Nunca perca a capacidade de aprender o que ainda não sabe.',
  'Mantenha a comunicação ativa nos bate-papos!',
  'Encare cada feedback como uma oportunidade de aprendizado.',
  'Responda com clareza e foco em soluções.',
]

export default {
  name: 'CulturaEsusFeedback',
  components: {
    CulturaHeader,
    CulturaDashboard,
    CulturaValues,
    CulturaCommunication,
    CulturaManifestoModal,
    CulturaMobileBottomNav,
  },
  data() {
    return {
      activeTab: 'dashboard',
      showManifesto: false,
      dailyQuote: DAILY_REMINDERS[0],
      reminders: DAILY_REMINDERS,
    }
  },
  methods: {
    refreshQuote() {
      const randomIndex = Math.floor(Math.random() * this.reminders.length)
      this.dailyQuote = this.reminders[randomIndex]
    },
  },
}
</script>

<style scoped>
.cultura-esus-feedback {
  background: #f8fafc;
  color: #0f172a;
}

.cultura-main {
  margin: 0 auto;
  padding: 24px 16px 80px;
  position: relative;
}
</style>
